{
  "processing": "Procesando verificación...",
  "loadingIframe": "Cargando verificación de identidad...",
  "issueTitle": "Problema con la verificación de identidad",
  "notConfigured": "La verificación de identidad no está configurada correctamente para este almacén.",
  "notSuccessful": "La verificación de identidad no fue exitosa. Por favor intenta de nuevo o contacta al almacén.",
  "couldNotCompleteProceed": "La verificación de identidad no pudo completarse, pero puedes continuar con el registro.",
  "processFailed": "Error al procesar la verificación de identidad. Por favor intenta de nuevo.",
  "processingFailedProceed": "El procesamiento de la verificación de identidad falló, pero puedes continuar con el registro.",
  "genericError": "Ocurrió un error durante la verificación de identidad. Por favor intenta de nuevo.",
  "issueProceed": "La verificación de identidad encontró un problema, pero puedes continuar con el registro.",
  "requiredTryAgain": "Se requiere la verificación de identidad para completar el registro. Por favor intenta de nuevo.",
  "checkInFailedTitle": "No se pudo completar el registro",
  "checkInFailedMessage": "No se pudo validar tu identificación"
}
